// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"aba2dd6b","232":"dcbbb974","237":"1e7f8da6","526":"c3fd7ca5"}[chunkId] + ".chunk.js";
};